export const AcademyUrls = {
  COURSES: '/lms/courses/jobseekers',
  COURSE_OVERVIEW: '/lms/courses/jobseekers/course-overview-content/{id}',
  COURSE_CONTENT: "/jobseekers/{jobseeker_id}/course-overview-content/{id}",
  COURSE_ENROLL: "/jobseekers/{jobseeker_id}/course/{id}/action/enroll",
  COMPLETE_CHAPTER: "/jobseekers/{jobseeker_id}/complete/{chapterId}",
  CATEGORIES: "/public/category",
  AUTHORS: "/lms/course/author",
  FEEDBACK: "/public/course/{courseId}/action/review",
  RESOURCES: "/coach/resources",
  RESOURCE_DETAIL: "/coach/resources/{resourceId}",
  RESOURCE_TYPES: "/api/resources/type",
  RESOURCE_CATEGORY: "/coach/resources/category",
  DISCIPLINES: "/api/open/discipline",
  REGISTER_EVENT: "/user/eventRegister",
};
